import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetSystemBannerDetailsById = ({ id }: { id: number }) => {
  const get = useTypedApiClient({
    path: '/admin/system-banners/{id}',
    method: 'get',
  })
  return useQuery({
    queryKey: ['/admin/system-banners/{id}', id],
    queryFn: async () => {
      const { data } = await get({ id })
      return data
    },
  })
}
